import { Suspense } from 'react';
import { LoadingPage } from '@/pages';
import { Page } from './Page';

export function PageWrapper() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <div className="flex flex-col gap-8 py-10 px-10 w-screen 2xl:max-w-(--breakpoint-2xl) 2xl:mx-auto">
        <Page />
      </div>
    </Suspense>
  );
}
